import type { EditorState } from '@tiptap/pm/state'

export interface SelectionContent {
  text: boolean
  observations: number
}

const NOTHING: SelectionContent = { text: false, observations: 0 }

// What the selection covers, so the floating toolbar offers only the actions
// that apply: text formatting needs text, freezing needs observation nodes.
// Observation nodes and instruments are inline atoms with no text, so a
// selection holding only them reads as empty to a text-only check.
export function selectionContent(state: EditorState): SelectionContent {
  const { from, to, empty } = state.selection
  if (empty) {
    return NOTHING
  }
  let observations = 0
  state.doc.nodesBetween(from, to, (node) => {
    if (
      node.type.name === 'observation' ||
      node.type.name === 'observation-panel'
    ) {
      observations += 1
    }
    return true
  })
  return { text: state.doc.textBetween(from, to).length > 0, observations }
}
